
        var result = require("!!../../../../node_modules/css-loader/index.js!./article-supplier.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/article-supplier.component.css
// module id = 2322
// module chunks = 1